module.exports = __webpack_public_path__ + "img/us-hi.e178e14e.svg";